import React from 'react';
import { connect } from 'react-redux';

import Email from './components/Email';
import Zipcode from './components/Zipcode';
import ThankYou from './components/ThankYou';


const Component = ({ step, children }) => {
  switch(step) {
    case "ENTER_ZIPCODE":
      return (
        <Zipcode />
      );
    case "THANK_YOU":
      return (
        <ThankYou />
      );
    default:
      return (
        <Email>
          { children }
        </Email>
      );
  }
}


Component.displayName = 'JoinWaitlistForm';

const getState = (state) => ({
  step: state.waitlist.step,
});

export default connect(getState)(Component);



// WEBPACK FOOTER //
// ./src/forms/JoinWaitlist/index.js